
  import { Component, Vue } from 'vue-property-decorator'
  import { QCard, QCardSection } from 'quasar'
  import Result from '../components/Result.vue'
  import * as Showdown from 'showdown'

  const markdownConverter = new Showdown.Converter()

  @Component({
    components: { QCard, QCardSection, Result }
  })

  export default class Profile extends Vue {
    get results() {
      return markdownConverter.makeHtml(this.$store.state.directus.config.results_advanced)
    }

    get splitResults() {
      return this.results.split((/(?=<h4>)/))
    }

    get view() {
      const desktop = 'q-pt-lg q-pl-xl q-pr-lg q-pb-lg'
      const mobile = 'q-ma-md'
      return this.$q.platform.is.desktop ? desktop : mobile
    }

    get resultClass() {
      if (this.results.length > 1) return 'q-mb-md'
    }
  }
